// src/components/admin/BillingOverview.jsx
import React, { useEffect, useState } from 'react';

const BillingOverview = () => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const res = await fetch('http://localhost:5003/admin/plan-summary');
      const data = await res.json();
      setPlans(data);
    } catch (err) {
      console.error('Error fetching plans:', err);
    }
  };

  return (
    <div className="space-y-4">
     

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {plans.map(plan => (
          <div key={plan.name} className="bg-white shadow border rounded-lg p-4">
            <h3 className="text-lg font-semibold mb-2 capitalize">{plan.name}</h3>
            <p className="text-sm text-gray-500">Users: {plan.count}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingOverview;
